<template>
  <div class="zyncro-loader" :style="loaderStyle" aria-hidden="true">
    <span class="zyncro-loader__halo"></span>
    <span class="zyncro-loader__mark">
      <img :src="iconSource" alt="" class="zyncro-loader__icon" />
    </span>
  </div>
</template>

<script>
import ZyncroIcon from '@/assets/branding/zyncro-icon.svg'

export default {
  name: 'ZyncroLoader',
  props: {
    width: {
      type: Number,
      default: 128,
    },
    height: {
      type: Number,
      default: 128,
    },
  },
  data() {
    return {
      iconSource: ZyncroIcon,
    }
  },
  computed: {
    loaderStyle() {
      const size = Math.min(this.width || 128, this.height || 128)

      return {
        width: size + 'px',
        height: size + 'px',
      }
    },
  },
}
</script>

<style scoped>
.zyncro-loader {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.zyncro-loader__halo,
.zyncro-loader__mark {
  position: absolute;
  inset: 0;
  border-radius: 50%;
}

.zyncro-loader__halo {
  background: rgba(10, 42, 69, 0.08);
  box-shadow: 0 0 0 0 rgba(10, 42, 69, 0.24);
  animation: zyncro-loader-pulse 1.65s ease-out infinite;
}

.zyncro-loader__mark {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  box-shadow: 0 14px 34px rgba(10, 42, 69, 0.18);
  transform: scale(0.72);
  animation: zyncro-loader-breathe 1.65s ease-in-out infinite;
}

.zyncro-loader__icon {
  display: block;
  width: 58%;
  height: 58%;
  object-fit: contain;
  filter: drop-shadow(0 8px 14px rgba(10, 42, 69, 0.22));
  animation: zyncro-loader-shine 1.65s ease-in-out infinite;
}

@keyframes zyncro-loader-pulse {
  0% {
    opacity: 0.9;
    transform: scale(0.72);
    box-shadow: 0 0 0 0 rgba(10, 42, 69, 0.24);
  }
  70% {
    opacity: 0;
    transform: scale(1);
    box-shadow: 0 0 0 18px rgba(10, 42, 69, 0);
  }
  100% {
    opacity: 0;
    transform: scale(1);
    box-shadow: 0 0 0 18px rgba(10, 42, 69, 0);
  }
}

@keyframes zyncro-loader-breathe {
  0%,
  100% {
    transform: scale(0.72);
  }
  50% {
    transform: scale(0.78);
  }
}

@keyframes zyncro-loader-shine {
  0%,
  100% {
    opacity: 0.86;
    transform: scale(0.96);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
